// Mobile menu popup – opens like the cart drawer (overlay + slide-in panel).
class MenuPopupDrawer extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('.menu-popup__trigger');
    this.popup = this.querySelector('.menu-popup');
    if (!this.trigger || !this.popup) return;

    // Move the popup to <body> so it isn't trapped in the sticky header's stacking context.
    // Remove any copy left behind by a previous render (theme editor section reload).
    document.querySelectorAll(`body > #${this.popup.id}`).forEach((el) => el.remove());
    document.body.appendChild(this.popup);

    this.trigger.addEventListener('click', () => this.open());
    this.popup
      .querySelectorAll('[data-menu-popup-close]')
      .forEach((el) => el.addEventListener('click', () => this.close()));
    this.popup.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
  }

  disconnectedCallback() {
    if (this.popup?.isConnected) this.popup.remove();
    document.body.classList.remove('overflow-hidden');
  }

  open() {
    // Same trick as cart-drawer: a timeout makes sure the transition runs.
    setTimeout(() => {
      this.popup.classList.add('active');
    });
    this.trigger.setAttribute('aria-expanded', 'true');

    this.popup.querySelector('.menu-popup__inner').addEventListener(
      'transitionend',
      () => trapFocus(this.popup, this.popup.querySelector('.menu-popup__close')),
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.popup.classList.remove('active');
    this.trigger.setAttribute('aria-expanded', 'false');
    removeTrapFocus(this.trigger);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('menu-popup-drawer', MenuPopupDrawer);
